import _ from 'lodash';
import Api from './Api';

const PORTFOLIOS_URL = `${process.env.REACT_APP_BASE_URL}/v2/portfolios`;

/**
 *
 * PORTFOLIOS
 */

export const getPortfolio = (id) => Api.get(`${PORTFOLIOS_URL}/${id}`);

export const addPortfolio = (data) => Api.post(PORTFOLIOS_URL, data);

export const deletePortfolio = (id) => Api.delete(`${PORTFOLIOS_URL}/${id}`);

export const editCash = (id, data) =>
  Api.put(`${PORTFOLIOS_URL}/${id}/cash`, data);

export const getPortfolioAverageBalances = (id, range) =>
  Api.get(`${PORTFOLIOS_URL}/${id}/metrics/average-balances?range=${range}`);

export const getPortfolioReturns = (id, range) =>
  Api.get(`${PORTFOLIOS_URL}/${id}/metrics/performance/returns?range=${range}`);

export const getPortfolios = () => Api.get(PORTFOLIOS_URL);

/**
 *
 * POSITIONS
 */

export const putPosition = (portfolioId, position) =>
  Api.put(`${PORTFOLIOS_URL}/${portfolioId}/positions`, position);

/**
 *
 * CONTRIBUTIONS
 */

export const addContribution = (id, data) =>
  Api.post(`${PORTFOLIOS_URL}/${id}/contributions`, data);

export const deleteContribution = (portfolioId, contributionId) =>
  Api.delete(
    `${PORTFOLIOS_URL}/${portfolioId}/contributions/${contributionId}`,
  );

export const getContributions = (id, offset, limit) =>
  offset && limit
    ? Api.get(
        `${PORTFOLIOS_URL}/${id}/contributions?offset=${offset}&limit=${limit}`,
      )
    : Api.get(`${PORTFOLIOS_URL}/${id}/contributions`);

/**
 *
 * TRANSACTIONS
 */

export const getTransactions = (id, offset, limit, filter) => {
  const params = new URLSearchParams();
  if (offset !== undefined) params.append('offset', offset);
  if (limit !== undefined) params.append('limit', limit);
  if (!_.isEmpty(filter)) {
    Object.entries(filter).forEach(([key, value]) => {
      if (value) params.append(key, value);
    });
  }
  const queryString = params.toString();
  const url = `${PORTFOLIOS_URL}/${id}/transactions${
    queryString ? `?${queryString}` : ''
  }`;

  return Api.get(url);
};

export const addTransaction = (id, data) =>
  Api.post(`${PORTFOLIOS_URL}/${id}/transactions`, data);

export const deleteTransaction = (portfolioId, transactionId) =>
  Api.delete(`${PORTFOLIOS_URL}/${portfolioId}/transactions/${transactionId}`);

/**
 *
 * DIVIDENDS
 */

export const getDividends = (id, offset, limit, status) => {
  const params = new URLSearchParams();
  if (offset !== undefined) params.append('offset', offset);
  if (limit !== undefined) params.append('limit', limit);
  if (status) params.append('status', status);
  const queryString = params.toString();

  return Api.get(
    `${PORTFOLIOS_URL}/${id}/dividends${queryString ? `?${queryString}` : ''}`,
  );
};

export const getDividendsYearly = (id) =>
  Api.get(`${PORTFOLIOS_URL}/${id}/dividends/yearly`);

export const getDividendsProjection = (id) =>
  Api.get(`${PORTFOLIOS_URL}/${id}/dividends/projection`);
